import { render } from "./edit-customer.vue?vue&type=template&id=1ee7d88d&scoped=true"
import script from "./edit-customer.vue?vue&type=script&lang=js"
export * from "./edit-customer.vue?vue&type=script&lang=js"

import "./edit-customer.vue?vue&type=style&index=0&id=1ee7d88d&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ee7d88d"]])

export default __exports__